const sortOptionsByType = {
    members: [
        {
            id: 1,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 2,
            optionLabel: 'First Name',
            selectedLabel: 'Sort By: First Name',
            indexSuffix: '_first_name_virtual',
            queryParam: 'sort_by_first_name',
        },
        {
            id: 3,
            optionLabel: 'Last Name',
            selectedLabel: 'Sort By: Last Name',
            indexSuffix: '_last_name_virtual',
            queryParam: 'sort_by_last_name',
        },
        {
            id: 4,
            optionLabel: 'Company',
            selectedLabel: 'Sort By: Company',
            indexSuffix: '_company_virtual',
            queryParam: 'sort_by_company',
        },
        {
            id: 5,
            optionLabel: 'Newest Members',
            selectedLabel: 'Sort By: Newest Members',
            indexSuffix: '_recently_joined_virtual',
            queryParam: 'sort_by_created_at',
        },
    ],
    companies: [
        {
            id: 6,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 7,
            optionLabel: 'Company Name',
            selectedLabel: 'Sort By: Company Name',
            indexSuffix: '_company_name_virtual',
            queryParam: 'sort_by_company',
        },
        {
            id: 8,
            optionLabel: 'Newest Companies',
            selectedLabel: 'Sort By: Newest Companies',
            indexSuffix: '_recently_joined_virtual',
            queryParam: 'sort_by_created_at',
        },
    ],
    articles: [
        {
            id: 9,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 10,
            optionLabel: 'Latest',
            selectedLabel: 'Sort By: Latest',
            indexSuffix: '_created_at_desc_virtual',
            queryParam: 'sort_by_created_at',
        },
    ],
    publications: [
        {
            id: 11,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 12,
            optionLabel: 'Recently Added',
            selectedLabel: 'Sort By: Recently Added',
            indexSuffix: '_created_at_desc',
            queryParam: 'sort_by_recently_added',
        },
        {
            id: 13,
            optionLabel: 'Title (A-Z)',
            selectedLabel: 'Sort By: Title(A-Z)',
            indexSuffix: '_title_asc',
            queryParam: 'sort_by_title',
        },
        {
            id: 14,
            optionLabel: 'Title (Z-A)',
            selectedLabel: 'Sort By: Title(Z-A)',
            indexSuffix: '_title_desc',
            queryParam: 'sort_by_title_reversed',
        },
    ],
    events: [
        {
            id: 15,
            optionLabel: 'Date',
            selectedLabel: 'Sort By: Date',
            indexSuffix: '_meeting_start_time_desc',
            queryParam: 'sort_by_start_time',
            default: true,
        },
        {
            id: 16,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
        },
        {
            id: 17,
            optionLabel: 'Title',
            selectedLabel: 'Sort By: Title',
            indexSuffix: '_title_asc',
            queryParam: 'sort_by_title',
        },
    ],
    everything: [
        {
            id: 18,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 19,
            optionLabel: 'Date',
            selectedLabel: 'Sort By: Date',
            indexSuffix: '_created_at_desc_virtual',
            queryParam: 'sort_by_created_at',
        },
        {
            id: 20,
            optionLabel: 'Title (A-Z)',
            selectedLabel: 'Sort By: Title',
            indexSuffix: '_title_asc_virtual',
            queryParam: 'sort_by_title',
        },
    ],
    properties: [
        {
            id: 21,
            optionLabel: 'Recent',
            selectedLabel: 'Sort By: Recent',
            indexSuffix: '_activated_at_desc',
            queryParam: 'sort_by_recent',
            default: true,
        },
        {
            id: 22,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: 'sort_by_best_match',
        },
        {
            id: 23,
            optionLabel: 'Name',
            selectedLabel: 'Sort By: Name',
            indexSuffix: '_title_asc',
            queryParam: 'sort_by_title',
        },
        {
            id: 24,
            optionLabel: 'Expiring Soon',
            selectedLabel: 'Sort By: Expiring Soon',
            indexSuffix: '_expires_at_asc',
            queryParam: 'sort_by_expiring_soon',
        },
    ],
    listed_properties: [
        {
            id: 21,
            optionLabel: 'Recent',
            selectedLabel: 'Sort By: Recent',
            indexSuffix: '_activated_at_desc',
            queryParam: 'sort_by_recent',
            default: true,
        },
        {
            id: 22,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: 'sort_by_best_match',
        },
        {
            id: 23,
            optionLabel: 'Name',
            selectedLabel: 'Sort By: Name',
            indexSuffix: '_title_asc',
            queryParam: 'sort_by_title',
        },
        {
            id: 24,
            optionLabel: 'Expiring Soon',
            selectedLabel: 'Sort By: Expiring Soon',
            indexSuffix: '_expires_at_desc',
            queryParam: 'sort_by_expiring_soon',
        },
    ],
    saved_searchable_members: [
        {
            id: 23,
            optionLabel: 'Recent Matches',
            selectedLabel: 'Sort By: Recent Matches',
            indexSuffix: '_search_created_desc',
            queryParam: 'sort_by_recent',
            default: true,
        },
        {
            id: 24,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
        },
        {
            id: 25,
            optionLabel: 'First Name',
            selectedLabel: 'Sort By: First Name',
            indexSuffix: '_sort_by_first_name',
            queryParam: 'sort_by_first_name',
        },
        {
            id: 26,
            optionLabel: 'Last Name',
            selectedLabel: 'Sort By: Last Name',
            indexSuffix: '_sort_by_last_name',
            queryParam: 'sort_by_last_name',
        },
        {
            id: 27,
            optionLabel: 'Company',
            selectedLabel: 'Sort By: Company',
            indexSuffix: '_sort_by_company',
            queryParam: 'sort_by_company',
        },
    ],
    member_events: [
        {
            id: 90,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 91,
            optionLabel: 'First Name',
            selectedLabel: 'Sort By: First Name',
            indexSuffix: '_sort_first_name_asc',
            queryParam: 'sort_by_first_name',
        },
        {
            id: 92,
            optionLabel: 'Last Name',
            selectedLabel: 'Sort By: Last Name',
            indexSuffix: '_sort_last_name_asc',
            queryParam: 'sort_by_last_name',
        },
        {
            id: 93,
            optionLabel: 'Company',
            selectedLabel: 'Sort By: Company',
            indexSuffix: '_sort_company_asc',
            queryParam: 'sort_by_company',
        },
        {
            id: 94,
            optionLabel: 'Newest Members',
            selectedLabel: 'Sort By: Newest Members',
            indexSuffix: '_sort_created_at_desc',
            queryParam: 'sort_by_created_at',
        },
        {
            id: 95,
            optionLabel: 'Latest Attendees',
            selectedLabel: 'Sort By: Latest Attendees',
            indexSuffix: '_sort_registered_at_desc',
            queryParam: 'sort_by_registered_at',
        },
    ],
};

const getAllSortOptions = () => {
    let allOptions = [];
    for (const [key, indexSuffix] of Object.entries(sortOptionsByType)) {
        allOptions = [...allOptions, ...indexSuffix];
    }
    return allOptions;
};

export { sortOptionsByType, getAllSortOptions };
